(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ogw-catalogue-explorer"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ogw-product-explorer')) {
  customElements.define('ogw-product-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.panels = Array.from(this.querySelectorAll('[data-ogwx-panel]'));
      if (!this.panels.length) return;
      const signal = this.controller.signal;
      const find = event => event.target.closest('[data-ogwx-select]');
      this.addEventListener('click', event => {
        const control = find(event);
        if (control && this.contains(control)) this.select(control.dataset.ogwxSelect);
      }, {signal});
      this.addEventListener('pointerover', event => {
        if (event.pointerType !== 'mouse') return;
        const control = find(event);
        if (control && this.contains(control)) this.select(control.dataset.ogwxSelect);
      }, {signal});
      this.addEventListener('focusin', event => {
        const control = find(event);
        if (control && this.contains(control)) this.select(control.dataset.ogwxSelect);
      }, {signal});
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('.ogwx-tab');
        if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        const tabs = Array.from(this.querySelectorAll('.ogwx-tab'));
        let index = tabs.indexOf(tab);
        if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = tabs.length - 1;
        event.preventDefault();
        tabs[index].focus();
      }, {signal});
      this.select(this.panels[0].dataset.ogwxPanel);
      this.setAttribute('data-ready','');
    }
    select(key) {
      const active = this.panels.find(panel => panel.dataset.ogwxPanel === key);
      if (!active || this.dataset.selected === key) return;
      this.dataset.selected = key;
      this.style.setProperty('--ogwx-accent',active.dataset.colour || '#177ca4');
      this.panels.forEach(panel => {panel.hidden = panel !== active;});
      this.querySelectorAll('[data-ogwx-select]').forEach(control => {
        const selected = control.dataset.ogwxSelect === key;
        if (control.tagName === 'BUTTON') control.setAttribute('aria-pressed',String(selected));
        control.classList.toggle('is-active',selected);
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      delete this.dataset.selected;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ogw-product-explorer"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ogw-product-explorer')) {
  customElements.define('ogw-product-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.panels = Array.from(this.querySelectorAll('[data-ogwx-panel]'));
      if (!this.panels.length) return;
      const signal = this.controller.signal;
      const find = event => event.target.closest('[data-ogwx-select]');
      this.addEventListener('click', event => {
        const control = find(event);
        if (control && this.contains(control)) this.select(control.dataset.ogwxSelect);
      }, {signal});
      this.addEventListener('pointerover', event => {
        if (event.pointerType !== 'mouse') return;
        const control = find(event);
        if (control && this.contains(control)) this.select(control.dataset.ogwxSelect);
      }, {signal});
      this.addEventListener('focusin', event => {
        const control = find(event);
        if (control && this.contains(control)) this.select(control.dataset.ogwxSelect);
      }, {signal});
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('.ogwx-tab');
        if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        const tabs = Array.from(this.querySelectorAll('.ogwx-tab'));
        let index = tabs.indexOf(tab);
        if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = tabs.length - 1;
        event.preventDefault();
        tabs[index].focus();
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-ogwx-panel]');
        if (panel && this.contains(panel)) this.select(panel.dataset.ogwxPanel);
      }, {signal});
      this.select(this.panels[0].dataset.ogwxPanel);
      this.setAttribute('data-ready','');
    }
    select(key) {
      const active = this.panels.find(panel => panel.dataset.ogwxPanel === key);
      if (!active || this.dataset.selected === key) return;
      this.dataset.selected = key;
      this.style.setProperty('--ogwx-accent',active.dataset.colour || '#177ca4');
      this.panels.forEach(panel => {panel.hidden = panel !== active;});
      this.querySelectorAll('[data-ogwx-select]').forEach(control => {
        const selected = control.dataset.ogwxSelect === key;
        if (control.tagName === 'BUTTON') control.setAttribute('aria-pressed',String(selected));
        control.classList.toggle('is-active',selected);
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      delete this.dataset.selected;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
